export enum APICallState {
    LOADING = 'loading',
    ERROR = 'error',
    SUCCESS = 'success',
}
